import { useResponsesStore } from "../stores/Responses";

const sendDataToGoogleSheet = async (data) => {
    const url = `/sheets/sheet.php`;

    const preparedData = prepareData(data);
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
            body: JSON.stringify(preparedData),
        });
        
        if (response.ok) {
            console.log('Data successfully sent to Google Sheets');
        } else {
            console.log('Error sending data', response  );
        }
    } catch (error) {
        console.error('Request failed:', error);
    }
};
  
export const sendToSheet = (data: any) => {
    // convert data to object with keys
    const formData = data.reduce((acc, field) => {
        const value = (field.value && typeof field.value === 'string' && field.id !== 'email') 
            ? field.value.replaceAll('_',  ' ').trim()
            : field.value;

        acc[field.id] = value || '';
        return acc;
    }, {});

console.log('sendToSheet', formData);

    sendDataToGoogleSheet(formData);
};

export const sendToSheetCheck = () => {
    // check if response has changed since last send - using hasChanges flag in Responses store
    const { hasChanges, setHasChanges, responses } = useResponsesStore.getState();

    // if no changes, don't send
    if (!hasChanges) return;

    // if no country is set, we don't know which sheet to send the data to
    if (!responses.some(r => r.id === 'country')) return;

    console.log('Sending to sheet...');

    // send to sheet
    sendToSheet(responses);
    setHasChanges(false);
}

// any data rep required for google sheets
const prepareData = (data) => {
    console.log('prepareData', data);
    
    // Ensure appliances array exists before modifying
    if (data.country === 'usa') {
        const appliances = data.appliances;

        if (Array.isArray(appliances)) {
            data.appliances = updateVolts(appliances)
        }
    }

    return data;
}

const updateVolts = (appliances) => {
    return appliances.map(appliance => ({
        ...appliance,
        volts: appliance.volts === "230" ? "120" : appliance.volts
    }));
}